module.exports = "/_next/static/images/check-excel-4d4fd7b1f5c81ae518029952972d2c28.svg";